import { render, staticRenderFns } from "./RecruitDetailsLayer.vue?vue&type=template&id=47dc6db9&scoped=true&"
import script from "./RecruitDetailsLayer.vue?vue&type=script&lang=js&"
export * from "./RecruitDetailsLayer.vue?vue&type=script&lang=js&"
import style0 from "./RecruitDetailsLayer.vue?vue&type=style&index=0&id=47dc6db9&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "47dc6db9",
  null
  
)

export default component.exports